module.exports = __webpack_public_path__ + "img/1.be8139d4.png";